import type { ChargePointResponse } from '@services/swagger-client/data-contracts.ts';
import type { ChargePoint } from '@shared/types/data.types.ts';

export class ChargePointMapper {
  static toChargePoint(apiResponse: ChargePointResponse): ChargePoint {
    return {
      ...apiResponse,
      hasBasicAuth: Boolean(apiResponse.basic_auth_pw),
      isRunningScenario: Boolean(apiResponse.running_scenario_name),
    };
  }
}
